import { TableColumn } from '@/classes'

export const Columns = [
  new TableColumn('Application Name', 'applicationName', true, 'asc', 'left'),
  new TableColumn('Created Date', 'createdDate', true, 'desc', 'left'),
  new TableColumn('Message', 'message', false, 'asc', 'left')
]
